'use client'

import { useContext, useEffect, useRef, useState } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  Button,
  CardActions,
  Chip,
  ClickAwayListener,
  Divider,
  Grid,
  Paper,
  Popper,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";

// third-party
import PerfectScrollbar from "react-perfect-scrollbar";

// project imports
import MainCard from "@/app/ui-component/cards/MainCard";
import Transitions from "@/app/ui-component/extended/Transitions";
import NotificationList from "./NotificationList";
// assets
import { useIntl } from "react-intl";
import NotificacaoStatusList from "@/app/services/admin/NotificacaoStatusList";
import { useDispatch } from "@/app/store";
import { useSelector } from "@/app/store";
import { getAllNotificacao, notificacaoCountNaoLida } from "@/app/store/slices/notificacaoUsuarios2";

import { useRouter } from 'next/navigation';

import { Link as  RouterLink} from 'next/link';
import { IconBell } from "@tabler/icons-react";
import NotificationRead from "@/app/views/pages/application/mail/NotificationRead";
import { getMessagemNaoLidaAdministrators, getMessagemNaoLidaStudents } from "@/app/services/admin/NotificacoesUsuario.services";
import { getIfCanDisconnect, getIfCanDisconnectStudent } from "@/app/services/admin/UserLogin.services";
import { handleRedirection } from "@/app/global-functions/handleRedirection";
import { getUniversityName } from "@/app/global-functions/getUniversityName";
import UserService from "@/app/services/admin/User.service";

// notification status options
// ==============================|| NOTIFICATION ||============================== //

const NotificationSection = () => {
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down("md"));

  const [open, setOpen] = useState(false);
  
  const prevOpen = useRef(open);
  const { paramMemoire } = useSelector((state) => state.diversParametersRedux);
  const [usuarioID, setUsuarioID] = useState(0);
  const dispatch = useDispatch();

  const [totalNaoLida, settotalNaoLida] = useState(0);

  const [studentMatriculaID, setstudentMatriculaID] = useState("");

  const [typeUtilisateur, settypeUtilisateur] = useState("");

  const [isLogged, setisLogged] = useState(false);

  // const { totalNaoLida } = useSelector((state) => state.notificacaoUsuarios2);
  const navigate = useRouter();
  const intervalRef = useRef(null);

  const [email, setemail] = useState("");
  const [abreviaturaUniversidade1, setAbreviaturaUniversidade] = useState("");

  const [userID, setuserID] = useState("");
  const [isRedirecting, setIsRedirecting] = useState(false); // State to prevent re-execution

  
  /**
   * anchorRef is used on different componets and specifying one type leads to other components throwing an error
   * */
  const anchorRef = useRef(null);
  const intl = useIntl();
  const [universityID, setUniversityID] = useState("");

  const fetchUniversityName = async () => {
    const university = await getUniversityName();
    setAbreviaturaUniversidade(university.abreviatura);

  };


  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);


  const getIfCanDisconnectFx = async (email) => {
    if (isRedirecting) return; // Exit the function if redirection is in progress
  
    // await getIfCanDisconnect(email).then(async (response) => {
    //   if (Number(response.countDisconnect) > 0) {
    //     const disconnect = {
    //       enligne: 0,
    //       disconectBeforeConnect: 0,
    //       tipo: "updateEnLigneNew",
    //       userID,
    //     };
  
    //     setIsRedirecting(true); // Set the state to indicate redirection is in progress
  
    //     await UserService.update(userID, disconnect).then(async () => {
    //       const university = await getUniversityName();
    //       setAbreviaturaUniversidade(university.abreviatura);
  
    //       // Perform redirection
    //       await handleRedirection(university.abreviatura, navigate);
  
    //       setIsRedirecting(false); // Reset the state after redirection
    //     });
    //   }
    //  /*  else {
    //     const disconnect = {
    //       enligne : 1,
    //       disconectBeforeConnect : 0,
    //       tipo : "updateEnLigneNew",
    //       userID
    //     }
    //    await  UserService.update(userID, disconnect).
    //     then((response) => {

    //     })
    //   } */

    // });
  };

  const getIfCanDisconnectFxStudent= async (email) => {
  /*   await getIfCanDisconnectStudent(email).then(async (response) => {
   
      if (Number(response.countDisconnect) > 0) {
        const disconnect = {
          enligne: 0,
          disconectBeforeConnect: 0,
          tipo: "updateEnLigneNew",
          userID,
        };
  
        setIsRedirecting(true); // Set the state to indicate redirection is in progress
  
        await UserService.update(userID, disconnect).then(async () => {
          const university = await getUniversityName();
          setAbreviaturaUniversidade(university.abreviatura);
  
          // Perform redirection
          await handleRedirection(university.abreviatura, navigate);
  
          setIsRedirecting(false); // Reset the state after redirection
        });
    
      }   // bloquer en ligne = true
   

    }); */
  };

  useEffect(() => {
    // Start the interval
    const intervalId = setInterval(() => {
     
      if(Number(typeUtilisateur) <3) {
        getIfCanDisconnectFx(email);
      }

      if(Number(typeUtilisateur) ===3) {
        getIfCanDisconnectFxStudent(email);
      }
     
    }, 10000); // Run every 5 seconds

    // Clean up the interval on component unmount
    return () => {
      clearInterval(intervalId);
    };
  }, [email]); // Dependency array to restart the interval if 'email' changes


  useEffect(() => {

    try {

        paramMemoire.map((item) => {

          setisLogged(item.isLoggedIn2)
          setemail(item.emaiUtulisateur);
        setUniversityID(item.universityID);
        setUsuarioID(item.id);
        setstudentMatriculaID(item.studentMatriculaID);
        settypeUtilisateur(item.typeUtilisateur);
        setuserID(item.id)

      })
    }catch(error) {
      console.log("error5555555555 " , error)
    }

    return () => {
    };
  }, [paramMemoire, userID, typeUtilisateur], email);

  useEffect(() => {

    paramMemoire.map((item) => {
      setisLogged(item.isLoggedIn2)
      setemail(item.emaiUtulisateur);

    });

    const fetchDataAndSetInterval = async () => {
  // console.log("icic8383883  ###  " , isLogged)
      if(Number(typeUtilisateur) === 3) {

        getMessagemNaoLidaStudents("getMensagensNaoLidas", universityID, studentMatriculaID)
        .then((response) => {
          settotalNaoLida(response.data[0].totalNaoLida);
        })
        .catch((e) => {
          console.log(e);
        });
      }

      if(Number(typeUtilisateur)  < 3) {
      //   console.log("readingNotification###")
        getMessagemNaoLidaAdministrators("getMensagensNaoLidasAdministratores", usuarioID)
        .then((response) => {
          settotalNaoLida(response.data[0].totalNaoLida);
        })
        .catch((e) => {
          console.log(e);
        });
      }
     
    };

    // Initial fetch when component mounts
    fetchDataAndSetInterval();

    fetchUniversityName();
  
    // Set up the interval to fetch data every 2 minutes (120,000 milliseconds)
    intervalRef.current = setInterval(fetchDataAndSetInterval, 30000);
  
    // Clean up the interval when component unmounts
    return () => clearInterval(intervalRef.current);
  
  }, [universityID, studentMatriculaID, isLogged], typeUtilisateur);  // Include the necessary dependencies

// Additional useEffect to clear the interval when the user logs out
useEffect(() => {
  return () => clearInterval(intervalRef.current);

    // Clean up the interval on component unmount
  }, [ usuarioID, paramMemoire]);


  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };


  
  return (
    <>
      <Box
        sx={{
          ml: 2,
          mr: 3,
          [theme.breakpoints.down("md")]: {
            mr: 2,
          },
        }}
      >
        <Avatar
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            transition: "all .2s ease-in-out",
            background:
              theme.palette.mode === "dark"
                ? theme.palette.dark.main
                : theme.palette.secondary.light,
            color:
              theme.palette.mode === "dark"
                ? theme.palette.warning.dark
                : theme.palette.secondary.dark,
            '&[aria-controls="menu-list-grow"],&:hover': {
              background:
                theme.palette.mode === "dark"
                  ? theme.palette.warning.dark
                  : theme.palette.secondary.dark,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.grey[800]
                  : theme.palette.secondary.light,
            },
          }}
          ref={anchorRef}
          aria-controls={open ? "menu-list-grow" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          color="inherit"
        >
          <IconBell stroke={1.5} size="2.5rem" />
          <label
            style={{
              fontSize: "14px",
              color: "white",
              fontWeight: 600,
              height: "15px",
              width: "30px",
              borderRadius: "50%",
              backgroundColor: "red",
              width: "30px",
              justifyItems: "center",
              justifyContent: "center",
            }}
          >
            {totalNaoLida} 
           

          </label>
        </Avatar>
      </Box>

      <Popper
        placement={matchesXs ? "bottom" : "bottom-end"}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [matchesXs ? 5 : 0, 20],
              },
            },
          ],
        }}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClose}>
            <Transitions
              position={matchesXs ? "top" : "top-right"}
              in={open}
              {...TransitionProps}
            >
              <Paper>
                {open && (
                  <MainCard
                    border={false}
                    elevation={16}
                    content={false}
                    boxShadow
                    shadow={theme.shadows[16]}
                  >
                    <Grid container direction="column" spacing={1}>
                      <Grid item xs={12}>
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="space-between"
                          sx={{ pt: 2, px: 2 }}
                        >
                          <Grid item>
                            <Stack direction="row" spacing={2}>
                              <Typography variant="subtitle1">
                                {intl.formatMessage({
                                  id: "messages_non_lues",
                                })}
                              </Typography>
                              <Chip
                                size="small"
                                 label={totalNaoLida}
                                sx={{
                                  color: theme.palette.background.default,
                                  bgcolor: theme.palette.warning.dark,
                                }}
                              />
                            </Stack>

                          </Grid>
                         
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                     
                          <hr/>
                          <NotificationList />
                        {/* </PerfectScrollbar> */}
                      </Grid>
                    </Grid>
                    <Divider />
                    <CardActions sx={{ p: 1.25, justifyContent: "center" }}>
                      <Button size="small" disableElevation
                      onClick={() => {
                      //  setreadMessageComponent(true);

                         setOpen(false)
                         return navigate.push(`/emailnotifications/EmailNew`);

                      }}>
                        {intl.formatMessage({ id: "ver_todas" })}
                      </Button>
                    </CardActions>
                  </MainCard>
                )}
              </Paper>
            </Transitions>
          </ClickAwayListener>
        )}
      </Popper>

      
    
    </>
  );
};

export default NotificationSection;
